module.exports = __webpack_public_path__ + "static/media/ExpEduCol.68049000.png";